const steps = [
  {
    number: '01',
    title: 'Consultation',
    description: 'On-site meeting to understand your vision, assess the space, and define the project scope.',
    image: '/images/gallery/pool-construction.jpg',
  },
  {
    number: '02',
    title: 'Design & Estimate',
    description: 'A clear, detailed proposal covering design, materials, timeline, and total cost.',
    image: '/images/gallery/pool-tile-detail.jpg',
  },
  {
    number: '03',
    title: 'Scope Review',
    description: 'Walk through every detail together. You approve with full understanding before ground breaks.',
    image: '/images/gallery/pool-tile-closeup.jpg',
  },
  {
    number: '04',
    title: 'Construction',
    description: 'Your pool is built with regular updates, photos, and full schedule transparency.',
    image: '/images/gallery/pool-slide-spa.jpg',
  },
  {
    number: '05',
    title: 'Handoff & Support',
    description: 'Final walkthrough, equipment training, and ongoing support after completion.',
    image: '/images/gallery/pool-completed-hero.jpg',
  },
];

export const ProcessSection = () => {
  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-32 bg-[#F8F6F3]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-amber-500 font-body text-xs font-semibold uppercase tracking-[0.25em] mb-4">
            Our Process
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-700 text-[#0F1D32] italic">
            How We Build Your Pool
          </h2>
          <p className="mt-4 text-base text-slate-500 font-body max-w-2xl mx-auto">
            A transparent, structured approach so you always know where your project stands.
          </p>
        </div>

        <div className="space-y-0">
          {steps.map((step, index) => (
            <div
              key={step.number}
              data-testid={`process-step-${step.number}`}
              className={`grid md:grid-cols-2 gap-0 ${index % 2 === 1 ? 'md:direction-rtl' : ''}`}
            >
              {/* Image */}
              <div className={`relative overflow-hidden h-[300px] md:h-[400px] ${index % 2 === 1 ? 'md:order-2' : ''}`}>
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-[#0F1D32]/20" />
                <span className="absolute bottom-4 left-6 font-heading text-7xl font-700 text-white/20 italic select-none">
                  {step.number}
                </span>
              </div>

              {/* Content */}
              <div className={`flex items-center bg-white px-8 md:px-16 py-12 ${index % 2 === 1 ? 'md:order-1' : ''}`}>
                <div>
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-amber-500 font-body text-xs font-bold uppercase tracking-widest">
                      Step {step.number}
                    </span>
                    <div className="h-[1px] w-12 bg-amber-500/30" />
                  </div>
                  <h3 className="font-heading text-2xl sm:text-3xl font-700 text-[#0F1D32] italic mb-3">
                    {step.title}
                  </h3>
                  <p className="text-base text-slate-500 font-body leading-relaxed max-w-md">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
